export default __webpack_public_path__ + "media/images/menu-icon/build-59a01ab6cd78e8c6fbfcf7663775854b.png";